import {
  Container,
  Typography,
  Grid,
  Box,
  Card,
  CardContent,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SchoolIcon from '@mui/icons-material/School';
import BuildIcon from '@mui/icons-material/Build';

const About = () => {
  const achievements = [
    'Πάνω από 8 χρόνια εμπειρίας στον κλάδο',
    'Επιτυχής ολοκλήρωση 50+ έργων',
    'Επαγγελματικές πιστοποιήσεις μηχανικού',
    'Βραβευμένες λύσεις σχεδιασμού',
    'Βιώσιμες πρακτικές κατασκευής',
  ];

  const teamMembers = [
    {
      name: 'Αθανάσιος Κρουσταλλάς',
      role: 'Κύριος Μηχανικός',
      description:
        'Μηχανικός με πάνω από 8 χρόνια εμπειρίας στη δομική μηχανική και τη διαχείριση έργων.',
    },
    {
      name: 'Κωνσταντίνος Παπαπαύλου',
      role: 'Τοπογράφος μηχανικός',
      description: 'Απόφοιτος του ΔΙΠΑΕ Σερρών με εξειδίκευση στις τοπογραφικές μελέτες, χαρτογράφηση και γεωδαιτικές μετρήσεις. Διαθέτει σημαντική εμπειρία σε έργα υποδομών και κτηματογράφησης.',
    },
    {
      name: 'Μαρία Μελικίδου',
      role: 'Πολιτικός Μηχανικός',
      description: 'Υπεύθυνη αρχιτεκτονικού σχεδιασμού και απόφοιτη του ΔΙΠΑΕ Σερρών.Συνδυάζει τεχνική κατάρτιση με ισχυρές σχεδιαστικές δεξιότητες.',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Company Overview */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h3" component="h1" align="center" gutterBottom>
          Σχετικά με Εμάς
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          paragraph
          sx={{ mb: 6 }}
        >
          Χτίζουμε την αριστεία μέσω καινοτομίας και εμπειρίας
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" paragraph>
              Είμαστε μια κορυφαία ομάδα που ασχολείται με την παράδοση
              καινοτόμων και βιώσιμων λύσεων για έργα κατασκευής και
              υποδομών. Η ομάδα μας έμπειρων επαγγελματιών φέρνει
              εμπειρία και αφοσίωση σε κάθε έργο που αναλαμβάνουμε.
            </Typography>
            <Typography variant="body1" paragraph>
              Με εστίαση στην ποιότητα, την ασφάλεια και την ικανοποίηση των πελατών, έχουμε
              καθιερωθεί ως αξιόπιστος συνεργάτης στον κλάδο της κατασκευής.
              Η ολοκληρωμένη προσέγγισή μας συνδυάζει την τεχνική αριστεία
              με πρακτικές λύσεις για να καλύψουμε τις ανάγκες των πελατών μας.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <List>
              {achievements.map((achievement, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <CheckCircleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={achievement} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>

      {/* Core Values */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" align="center" gutterBottom>
          Οι Βασικές Αξίες μας
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <EngineeringIcon sx={{ fontSize: 48, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" align="center" gutterBottom>
              Αριστεία
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary">
              Δέσμευση στην παράδοση της υψηλότερης ποιότητας σε κάθε έργο
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <SchoolIcon sx={{ fontSize: 48, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" align="center" gutterBottom>
              Καινοτομία
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary">
              Υιοθέτηση νέων τεχνολογιών και μεθοδολογιών
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <BuildIcon sx={{ fontSize: 48, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" align="center" gutterBottom>
              Ακεραιότητα
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary">
              Διατήρηση των υψηλότερων ηθικών προτύπων σε όλες τις λειτουργίες
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Team Section */}
      <Box>
        <Typography variant="h4" component="h2" align="center" gutterBottom>
          Η Ομάδα μας
        </Typography>
        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          paragraph
          sx={{ mb: 4 }}
        >
          Γνωρίστε τους έμπειρους επαγγελματίες μας
        </Typography>
        <Grid container spacing={4}>
          {teamMembers.map((member, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Avatar
                      src={index === 0 ? '/images/kroustallas.jpg' : index === 2 ? '/images/melikidou.png' : undefined}
                      alt={index === 0 
                        ? 'Κρουσταλλάς Αθανάσιος - Πολιτικός Μηχανικός ΑΠΘ - Μηχανικός στις Σέρρες, Τούζλα, Κερδύλλια και Βόρεια Ελλάδα'
                        : index === 2 
                        ? 'Μαρία Μελικίδου - Πολιτικός Μηχανικός - Συνεργάτης του γραφείου Κρουσταλλά στη Βόρεια Ελλάδα'
                        : `${member.name} - ${member.role} - Μέλος της ομάδας του Κρουσταλλά`
                      }
                      sx={{
                        width: 100,
                        height: 100,
                        margin: '0 auto',
                        bgcolor: index === 2 ? 'white' : 'primary.main',
                        border: index === 2 ? '1px solid #eee' : 'none',
                      }}
                    >
                      {(index !== 0 && index !== 2) && member.name.split(' ').map((n) => n[0]).join('')}
                    </Avatar>
                  </Box>
                  <Typography variant="h6" align="center" gutterBottom>
                    {member.name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    align="center"
                    color="primary"
                    gutterBottom
                  >
                    {member.role}
                  </Typography>
                  <Typography variant="body2" align="center" color="text.secondary">
                    {member.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default About; 